import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HeroSection from "./components/HeroSection";
import CardsSection from "./components/CardsSection";
import UpdatesSection from "./components/UpdatesSection";
import AppSection from "./components/AppSection";
import FeaturesSection from "./components/FeaturesSection";
import TopicsSection from "./components/TopicsSection";
import MediaSection from "./components/MediaSection";
import CarouselSection from "./components/CarouselSection";
import RankingSection from "./components/RankingSection";
import AboutSection from "./components/AboutSection";
import IndexSection from "./components/IndexSection";
import ContactSection from "./components/ContactSection";
import FaqSection from "./components/FaqSection";
import CommentsSection from "./components/CommentsSection";

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <CardsSection />
        <UpdatesSection />
        <AppSection />
        <FeaturesSection />
        <TopicsSection />
        <MediaSection />
        <CarouselSection />
        <RankingSection />
        <AboutSection />
        <IndexSection />
        <ContactSection />
        <FaqSection />
        <CommentsSection />
      </main>
      <Footer />
    </>
  );
}